<template>
  <section class="section pricing-faq">
    <div class="container">
      <h2 class="section__title pricing-faq__title">
        Частые вопросы перед<br />
        приобретением Хантфлоу
      </h2>
      <div class="pricing-faq__items">
        <template v-for="({ i, q, a, b }, j) in items[region]">
          <dl :key="i" :data-expanded="expanded[j]" class="pricing-faq-item">
            <dt @click="expand(j)">
              <svg v-if="mediaLgMatches" width="110" height="94" role="img" class="pricing-faq-item__icon">
                <use :xlink:href="iconPath(i)"></use>
              </svg>
              <div v-html="q" class="pricing-faq-item__question"></div>
              <div class="pricing-faq-item__toggle">
                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" role="img">
                  <path fill="#16BF54" d="M19 0h3v42h-3z" />
                  <path fill="#16BF54" d="M0 23v-3h42v3z" />
                </svg>
              </div>
            </dt>
            <dd>
              <div>
                <div v-html="a" class="pricing-faq-item__answer"></div>
                <button v-if="b" type="button" class="button button--sm" data-modal="#demoRequestModal">
                  Оставить заявку
                </button>
              </div>
            </dd>
          </dl>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import icons from './icons.svg';

const items = {
  ru: [
    {
      i: 'cloud-advantages',
      q: 'В&nbsp;чем главные преимущества облачного рекрутингового сервиса?',
      a: 'Все компании в&nbsp;мире переходят на&nbsp;облачные (SaaS) сервисы. У&nbsp;них много неоспоримых преимуществ: доступность на&nbsp;любом устройстве в&nbsp;любой точке мира, отсутствие затрат на&nbsp;техническую поддержку в&nbsp;штате, постоянные релизы новинок и&nbsp;быстрое исправление ошибок.',
    },
    {
      i: 'which-tariff',
      q: 'Какой тариф мне подойдет?',
      a: `<p>Если вам важно получить все передовые возможности автоматизации для ускорения закрытия вакансий и&nbsp;решения любых задач рекрутимента, то&nbsp;тариф Максимальный&nbsp;&mdash; для вас. Это самый полнофункциональный тариф Хантфлоу с&nbsp;большим количеством уникальных функциональных возможностей.</p>
      <p>Ключевые инструменты для автоматизации рутины, работы с&nbsp;заказчиками и&nbsp;рекрутинговой аналитики собраны в&nbsp;тарифе Профессиональный.</p>
      <p>Премьер&nbsp;&mdash; это выделенное направление Хантфлоу по&nbsp;работе с&nbsp;крупными компаниями по&nbsp;индивидуальным процедурам приобретения и&nbsp;сопровождения Хантфлоу и&nbsp;с&nbsp;реализацией индивидуальных IT-решений.</p>
      <p>Если вы&nbsp;не&nbsp;можете определиться, оставьте заявку&nbsp;&mdash; мы&nbsp;поможем выбрать тариф, который поможет решить задачи рекрутмента вашей компании.</p>`,
      b: true,
    },
    {
      i: 'db-migrate',
      q: 'Вы&nbsp;сможете перенести мою базу резюме при переходе на&nbsp;Хантфлоу?',
      a: `<p>Да, мы&nbsp;переносим наработанные базы резюме из&nbsp;других рекрутинговых систем или файлов в&nbsp;Хантфлоу. Сроки и&nbsp;стоимость работ зависят от&nbsp;количества резюме и&nbsp;источника, откуда нужно забрать базу.</p>`,
    },
    {
      i: 'payment-methods',
      q: 'Какие методы оплаты возможны?',
      a: 'Хантфлоу оплачивается ежегодно. Оплата по&nbsp;счету-оферте или двустороннему договору, если сумма большая. Возможна оплата по&nbsp;карте как в&nbsp;интернет-магазине.',
    },
    {
      i: 'new-features',
      q: 'Если у&nbsp;вас выйдет какая-то новинка, она будет мне доступна?',
      a: 'Конечно! Мы&nbsp;постоянно улучшаем функциональность сервиса и&nbsp;все клиенты получают все новинки Хантфлоу в&nbsp;рамках своего тарифа.',
    },
    {
      i: 'tariff-upgrade',
      q: 'Можно&nbsp;ли перейти на&nbsp;тариф выше? А&nbsp;увеличить число рекрутеров?',
      a: 'Да, в&nbsp;любой момент вы&nbsp;можете перейти на&nbsp;более функциональный тариф или увеличить число рабочих мест рекрутера. Вам надо будет просто доплатить разницу в&nbsp;стоимости до&nbsp;конца оплаченного периода доступа.',
    },
    {
      i: 'safety-and-reliability',
      q: 'Как Хантфлоу обеспечивает безопасность и&nbsp;надежность работы?',
      a: `<ol><li>Мы&nbsp;ежегодно успешно проходим независимый аудит безопасности инфраструктуры и&nbsp;приложения Хантфлоу в&nbsp;крупнейшей международной компании <a href="https://www.bishopfox.com" target="_blank">Bishop Fox</a>.</li>
      <li>Все данные хранятся в&nbsp;дата-центре Selectel уровня надежности Tier&nbsp;III.</li>
      <li>В&nbsp;Хантфлоу настроено непрерывное резервное копирование всех данных клиентов на&nbsp;резервный сервер.</li>
      <li>В&nbsp;Хантфлоу нет ни&nbsp;одного внешнего скрипта вроде Яндекс.Метрики, Google Analytics, Facebook Pixel, чатов поддержки Carrot Quest, JivoSite, Chatra и&nbsp;других внешних скриптов после входа в&nbsp;личный кабинет. Технически все они имеют доступ к&nbsp;вашим данным, что противоречит приватности персональных данных.</li></ol>`,
    },
    {
      i: '152-fz',
      q: 'Как Хантфлоу выполняет 152-ФЗ &laquo;О&nbsp;персональных данных&raquo;?',
      a: `Мы&nbsp;строго следим за&nbsp;выполнением закона 152-ФЗ. Сервера Хантфлоу находятся в&nbsp;России, в&nbsp;дата-центре Selectel, компания входит в&nbsp;реестр операторов персональных данных, а&nbsp;ИТ-инфраструктура защищена аппаратным фаерволлом.`,
    },
    {
      i: 'use-termination',
      q: 'Что будет с&nbsp;базой, если мы&nbsp;прекратим использовать Хантфлоу?',
      a: `Мы&nbsp;по&nbsp;договору обязуемся бесплатно вернуть клиенту базу в&nbsp;универсальном компьютерном формате JSON со&nbsp;всеми вакансиями, резюме, взаимосвязями, комментариями, хронологией и&nbsp;пользователями для переноса в&nbsp;любую другую программу. Или&nbsp;же просто резюме в&nbsp;PDF или DOCX, по&nbsp;вашему усмотрению.`,
    },
  ],
  'kz-uz': [
    {
      i: 'cloud-advantages',
      q: 'В&nbsp;чем главные преимущества облачного рекрутингового сервиса?',
      a: 'Все компании в&nbsp;мире переходят на&nbsp;облачные (SaaS) сервисы. У&nbsp;них много неоспоримых преимуществ: доступность на&nbsp;любом устройстве в&nbsp;любой точке мира, отсутствие затрат на&nbsp;техническую поддержку в&nbsp;штате, постоянные релизы новинок и&nbsp;быстрое исправление ошибок.',
    },
    {
      i: 'which-tariff',
      q: 'Какой тариф мне подойдет?',
      a: `<p>Тариф Профессиональный включает в&nbsp;себя полный набор инструментов для сокращения срока закрытия вакансий и&nbsp;решения бизнес-задач рекрутинга. Он&nbsp;подойдет большинству компаний. В&nbsp;тариф Максимальный входят решения для крупных компаний&nbsp;&mdash; например, план подбора, автоматический расчет дедлайнов и&nbsp;оценка рекрутмента заказчиками. А&nbsp;тариф Энтерпрайз помогает полностью соответствовать требованиям корпоративной безопасности.</p>
      <p>Если вы&nbsp;не&nbsp;можете определиться, оставьте заявку&nbsp;&mdash; мы&nbsp;поможем выбрать тариф, который поможет решить задачи вашего рекрутмента.</p>`,
      b: true,
    },
    {
      i: 'db-migrate',
      q: 'Вы&nbsp;сможете перенести мою базу резюме при переходе на&nbsp;Хантфлоу?',
      a: `<p>Да, мы&nbsp;переносим наработанные базы резюме из&nbsp;других рекрутинговых систем или файлов в&nbsp;Хантфлоу. Сроки и&nbsp;стоимость работ зависят от&nbsp;количества резюме и&nbsp;источника, откуда нужно забрать базу.</p>`,
    },
    {
      i: 'payment-methods',
      q: 'Какие методы оплаты возможны?',
      a: 'Хантфлоу оплачивается ежегодно. Оплата по&nbsp;счету-оферте или двустороннему договору, если сумма большая.',
    },
    {
      i: 'new-features',
      q: 'Если у&nbsp;вас выйдет какая-то новинка, она будет мне доступна?',
      a: 'Конечно! Мы&nbsp;постоянно улучшаем функциональность сервиса и&nbsp;все клиенты получают все новинки Хантфлоу в&nbsp;рамках своего тарифа.',
    },
    {
      i: 'tariff-upgrade',
      q: 'Можно&nbsp;ли перейти на&nbsp;тариф выше? А&nbsp;увеличить число рекрутеров?',
      a: 'Да, в&nbsp;любой момент вы&nbsp;можете перейти на&nbsp;более функциональный тариф или увеличить число рабочих мест рекрутера. Вам надо будет просто доплатить разницу в&nbsp;стоимости до&nbsp;конца оплаченного периода доступа.',
    },
    {
      i: 'safety-and-reliability',
      q: 'Как Хантфлоу обеспечивает безопасность и&nbsp;надежность работы?',
      a: `<ol><li>Мы&nbsp;ежегодно успешно проходим независимый аудит безопасности инфраструктуры и&nbsp;приложения Хантфлоу в&nbsp;крупнейшей международной компании <a href="https://www.bishopfox.com" target="_blank">Bishop Fox</a>.</li>
      <li>Все данные хранятся в&nbsp;дата-центре Selectel уровня надежности Tier&nbsp;III.</li>
      <li>В&nbsp;Хантфлоу настроено непрерывное резервное копирование всех данных клиентов на&nbsp;резервный сервер.</li>
      <li>В&nbsp;Хантфлоу нет ни&nbsp;одного внешнего скрипта вроде Яндекс.Метрики, Google Analytics, Facebook Pixel, чатов поддержки Carrot Quest, JivoSite, Chatra и&nbsp;других внешних скриптов после входа в&nbsp;личный кабинет. Технически все они имеют доступ к&nbsp;вашим данным, что противоречит приватности персональных данных.</li></ol>`,
    },
    {
      i: 'use-termination',
      q: 'Что будет с&nbsp;базой, если мы&nbsp;прекратим использовать Хантфлоу?',
      a: `Мы&nbsp;по&nbsp;договору обязуемся бесплатно вернуть клиенту базу в&nbsp;универсальном компьютерном формате JSON со&nbsp;всеми вакансиями, резюме, взаимосвязями, комментариями, хронологией и&nbsp;пользователями для переноса в&nbsp;любую другую программу. Или&nbsp;же просто резюме в&nbsp;PDF или DOCX, по&nbsp;вашему усмотрению.`,
    },
  ],
};

export default {
  name: 'PricingFaq',
  props: {
    region: {
      type: String,
      default: 'ru',
    },
  },
  data() {
    return {
      items,
      icons: icons,
      expanded: {},
      mediaLgMatches: null,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaLg() {
      return window.matchMedia(`(min-width: ${this.breakpoints.lgMin})`);
    },
  },
  mounted() {
    this.isMediaLg();
    this.mediaLg.addEventListener('change', this.isMediaLg, { passive: true });
  },
  beforeDestroy() {
    this.mediaLg.removeEventListener('change', this.isMediaLg);
  },
  methods: {
    expand(i) {
      Vue.set(this.expanded, i, !this.expanded[i]);
    },
    iconPath(i) {
      return `${icons}#${i}`;
    },
    isMediaLg() {
      this.mediaLgMatches = this.mediaLg.matches;
    },
  },
};
</script>
